export const MATERIAL_TABLE_COLUMN_TYPES = [
  'string',
  'boolean',
  'numeric',
  'date',
  'datetime',
  'time',
  'currency',
]

export const getMaterialTableColumnType = (type) => {
  if (MATERIAL_TABLE_COLUMN_TYPES.includes(type)) return type

  return undefined
}

export const applyMaterialTableColumnType = (column = {}, type) => {
  if (!column.typeField) {
    column.typeField = type
  }

  let materialTableType = getMaterialTableColumnType(type)
  if (materialTableType) {
    column.type = materialTableType
  } else {
    delete column.type
  }

  return column
}
